"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pinoutValidationResultSchema = void 0;
const z = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
exports.pinoutValidationResultSchema = z.object({
    referenceDesignator: z.string(),
    packageName: z.string(),
    customerSignal: z.string(),
    customerPin: z.string(),
    packageStoreSignal: z.string(),
    packageStorePin: z.string(),
    status: z.nativeEnum(sigma_engine_shared_1.PinoutValidationResultEntryStatus),
    packageId: z.string(),
});
//# sourceMappingURL=pinout-validation-result.js.map